module.exports = __webpack_public_path__ + "static/media/59_copper_metal_seamless.a844d158.jpg";